/**
 * Landing page: video YouTube "click to load".
 * La copertina è un'immagine locale; l'iframe (youtube-nocookie) viene creato solo al clic.
 * Markup: blocks/landing/landing_video.twig → .lp-video__shell[data-youtube]
 */
document.querySelectorAll('.lp-video__shell[data-youtube]').forEach(function (shell) {
	var button = shell.querySelector('.lp-video__poster');
	if (!button) return;

	button.addEventListener('click', function () {
		var id = shell.getAttribute('data-youtube');

		// In file:// YouTube non riceve un Referer valido (errore 153): apri su YouTube.
		if (window.location.protocol === 'file:') {
			window.open('https://www.youtube.com/watch?v=' + id, '_blank', 'noopener,noreferrer');
			return;
		}

		var iframe = document.createElement('iframe');
		iframe.title = shell.getAttribute('data-title') || 'Video';
		iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.referrerPolicy = 'strict-origin-when-cross-origin';
		iframe.allowFullscreen = true;
		shell.replaceChildren(iframe);
	});
});
